import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState, useRef} from 'react';
import {connect} from 'react-redux';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';
import {initBlock, resetBlock, goToPage, reportDWH} from './GenericWizardBlockSlice';
import {getWizardScreens} from './GenericWizardBlockThunk';
import ScreenPage from './pages/ScreenPage/ScreenPage';
import ErrorPage from './pages/ErrorPage/ErrorPage';
import SuccessPage from './pages/SuccessPage/SuccessPage';
import CallBackPage from './pages/CallBackPage/CallBackPage';
import arrow from './images/arrow.svg';

const GenericWizardBlock = (props) => {
  const hasHandledBackNavigation = useRef(false);
  let currentView = null;
    useExtendedEffect((runSideEffects) => {
    props.initBlock({epiBlockData: props.iContent});
    getWizardScreens();
    return () => {
      if (runSideEffects()) {
        props.resetBlock();
      }
    };
  }, []);

  useEffect(() => {
    const handlePopState = () => {
      if (!window.location.hash && !hasHandledBackNavigation.current) {
        hasHandledBackNavigation.current = true;
        window.history.go(-1);
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  async function getWizardScreens() {
    const response = await props.getWizardScreens();
    if (response.payload.wizard) {
      const firstScreenId = response.payload.wizard.firstScreenId;
      const title = response.payload.screens?.find((x) => x.id == firstScreenId)?.title ?? '';
      props.goToPage({page: 'screenPage', screenId: firstScreenId});
      props.reportDWH({actionType: 'SupportStepGuide', status: 'Ongoing', messageText: 'Support Step Guide Displayed', title: title});
    }
  }

  useClearStateResetFlag();

  const handleOnLinkClick = () => {
    window.history.back();
  };

  switch (props.page) {
    case 'screenPage':
      currentView = <ScreenPage />;
      break;
    case 'successPage':
      currentView = <SuccessPage />;
      break;
    case 'errorPage':
      currentView = <ErrorPage />;
      break;
    case 'callBackPage':
      currentView = <CallBackPage />;
      break;
  }

  return (
    <div
      className={
        props?.templateWizard === 'GOLAN'
          ? 'generic-wizard-block golan'
          : props?.templateWizard === 'DINAMIKA'
          ? 'generic-wizard-block dinamika'
          : 'generic-wizard-block'
      }
    >
      {props.page == 'screenPage' && (
        <div className='wrapper-back-button'>
          <a href='#' className='button' onClick={handleOnLinkClick}>
            {' '}
            <Image src={arrow} alt='icon' /> חזרה{' '}
          </a>
        </div>
      )}
      <div className='page-wrapper'>{currentView}</div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    page: state.genericWizardBlock.page,
    templateWizard: state.genericWizardBlock.epiBlockData?.templateWizard
  };
};

const mapDispatchToProps = {
  resetBlock,
  initBlock,
  getWizardScreens,
  goToPage,
  reportDWH,
};

export default connect(mapStateToProps, mapDispatchToProps)(GenericWizardBlock);
